export default {
  gradeFlawlessScreenlessDevices: {
    id: 'no_grade_step_body_accept',
    defaultMessage: 'Almost no signs of use',
  },
  gradeGentlyUsedScreenlessDevices: {
    id: 'no_grade_step_body_decline',
    defaultMessage: 'Gently used',
  },
}
